module.exports = __webpack_public_path__ + "1facc27ce14cf720eba06cd55467bbdc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/quiz-complete.png
// module id = 308
// module chunks = 0